// 가격변경 모달창

import { useEffect, useRef, useState } from "react";
import { useCalendarCardInfContext } from "../context";
import { priceFormat, regNum } from "components/utils/comm";
import i18n from "locales/i18n";
import { langProps } from "interface/index";
import BaseModal from "components/modal/base";
import { useTranslation } from "react-i18next";
import { useUpdatePrice } from "./handlers";

type IProps = {
  isOpen: boolean;
  onClose: () => void;
};
export default function PriceModal({ isOpen, onClose }: IProps) {
  const { t } = useTranslation();
  const langCd = i18n.language;
  const { cardInf } = useCalendarCardInfContext();
  const preSellPri = cardInf?.sellPri ?? "";
  const txtRef = useRef<HTMLParagraphElement | null>(null);
  const [sellPri, setSellPri] = useState(""); // 입력된 가격

  const txt = {
    ko: `현재 판매가격은 <b class='text-red-500 px-1'>${priceFormat({
      price: preSellPri,
    })} </b>입니다.
    <br />
    하기 변경할 삼품가격을 입력하여 주세요.
    `,
    en: `The current selling price is <b class='text-red-500 px-1'>${priceFormat(
      { price: preSellPri, currSymbol: false }
    )}</b>.<br />
    Please enter the updated price for the product below.
    `,
  };

  const { onUpdatePrice } = useUpdatePrice();
  useEffect(() => {
    if (txtRef.current) {
      txtRef.current.innerHTML = txt[langCd as keyof langProps];
    }
  }, [txt, langCd]);
  return (
    <BaseModal isOpen={isOpen} title={t("md_ttl_edit_price")} onClose={onClose}>
      <div className="text-center font-bold">
        <p className="text-xs" ref={txtRef} />
        <div className="flex justify-center pt-3">
          <label htmlFor="" className="w-[70px] font-bold">
            {t("txt_rm_price")} :
          </label>
          <input
            type="text"
            name="sellPri"
            className="h-[28px] flex-1"
            maxLength={20}
            defaultValue={""}
            onChange={(e) => {
              const value = e.currentTarget.value.replace(/[₩,]/g, "");
              if (!regNum.test(value)) {
                return (e.currentTarget.value = "");
              }

              e.currentTarget.value =
                priceFormat({ price: value, currSymbol: false }) || "";
              setSellPri(e.currentTarget.value);
            }}
          />
        </div>
      </div>
      <div className="flex justify-center pt-5">
        <button
          className="btn bg-red-400"
          onClick={() => onUpdatePrice(sellPri)}
        >
          변경
        </button>
      </div>
    </BaseModal>
  );
}
